import { render } from "./PianoKeyboard.vue?vue&type=template&id=0c00e288&scoped=true&ts=true"
import script from "./PianoKeyboard.vue?vue&type=script&lang=ts"
export * from "./PianoKeyboard.vue?vue&type=script&lang=ts"

import "./PianoKeyboard.vue?vue&type=style&index=0&id=0c00e288&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c00e288"]])

export default __exports__